import { HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Motion from '@/components/base/motion'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'

import { timelineRevealAnimation } from './animations'
import { cn } from '@/lib/utils'

export type TimelineProps = HTMLAttributes<HTMLElement> & {
  steps: {
    overline: string
    title: string
  }[]
}

const Timeline = ({ steps = [], ...props }: TimelineProps) => {
  return (
    <Motion animation={timelineRevealAnimation}>
      {(motionRef) => (
        <Section ref={motionRef} {...props}>
          <Container>
            <Grid>
              <div className={cn('col-span-4 md:col-span-6 lg:col-span-12')}>
                <ul
                  className={cn(
                    'flex flex-col items-center space-y-[3.2rem]',
                    'xl:-my-[1rem] xl:flex-row xl:flex-nowrap xl:items-start xl:space-x-[3.2rem] xl:space-y-0 xl:overflow-auto xl:py-[1rem]',
                    {
                      'mx-auto max-w-[50rem]': steps.length < 3
                    }
                  )}
                >
                  {steps.map(({ overline, title }, index) => (
                    <li
                      key={`step-${index}`}
                      className={cn(
                        'w-0 min-w-[20rem] flex-[1_0_0]',
                        'grid gap-y-[0.8rem] text-center xl:gap-y-[1.6rem]'
                      )}
                    >
                      {overline ? (
                        <div className="overflow-hidden">
                          <Typography
                            variant="label"
                            paragraph
                            className="font-gillsans uppercase text-copper"
                            data-motion-overline
                          >
                            {overline}
                          </Typography>
                        </div>
                      ) : null}

                      {title ? (
                        <div className="overflow-hidden">
                          <Typography
                            variant="body"
                            paragraph
                            className="font-gillsans"
                            data-motion-title
                          >
                            {title}
                          </Typography>
                        </div>
                      ) : null}
                    </li>
                  ))}
                </ul>
              </div>
            </Grid>
          </Container>
        </Section>
      )}
    </Motion>
  )
}

export default Timeline
